<div class="range-slider-wrap">
    <mat-slider (change)="valueChange()" (input)="minValueInput($event)" [(ngModel)]="minValue" [color]="minColor"
        [displayWith]="formatLabel" [max]="max" [min]="min" [thumbLabel]="thumbLabel"
        class="range-slider range-slider--min slider-min-value" [step]="step">
    </mat-slider>
    <mat-slider (change)="valueChange()" (input)="maxValueInput($event)" [(ngModel)]="maxValue" [color]="maxColor"
        [displayWith]="formatLabel" [max]="max" [min]="min" [thumbLabel]="thumbLabel"
        class="range-slider range-slider--max slider-max-value" [step]="step">
    </mat-slider>
</div>